import React from 'react';
import ReactDOM from 'react-dom/client';
import GiftingModule from './components/gifting';

export const isDev = process.env.NODE_ENV === 'development';

const RenderBlock = document.getElementById('react-gifting-module') as HTMLElement;

if (RenderBlock) {
    const root = ReactDOM.createRoot(RenderBlock);
    const enableMobile = RenderBlock.getAttribute('data-enable-mobile');
    const enableDesktop = RenderBlock.getAttribute('data-enable-desktop');
    const productColourSwatches = RenderBlock.getAttribute('data-product-colour-swatches');
    const cartIconClass = RenderBlock.getAttribute('data-cart-class');
    const productTitle = RenderBlock.getAttribute('data-product-title');
    const shopCurrency = RenderBlock.getAttribute('data-shop-currency');

    root.render(
        <GiftingModule
        
            productTitle={productTitle || ''}
            cartIconClass={cartIconClass || ''}
            productColourSwatches={(productColourSwatches || '').split(',')}
            shopCurrency={shopCurrency || ''}
        />,
    );
}
